export const initRegion = {
  apac: false,
  africa: false,
  europe: false,
  middleEast: false,
  theAmericas: false,
};
